<template>
  <div class="main wh100">
    <div class="header" v-show="showTop">
      <div class="header-logo">
        <!--<img src="../assets/logo.png" alt style="width: 40px" />-->
        <span style="margin-left:0">{{ title }}</span>
      </div>
      <div class="header-menu">
        <HorizontalMenu :rootID="0" style="margin-right: 10px" ></HorizontalMenu>
        <person-center></person-center>
      </div>
    </div>
    <div class="content">
      <div class="aside">
        <VerticalMenu v-if="leftMenuVisible"></VerticalMenu>
      </div>

      <div class="view-content">
        <transition name="fade-transform" mode="out-in">
          <router-view></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import VerticalMenu from "../components/Menu/VerticalMenu";
import HorizontalMenu from "../components/Menu/HorizontalMenu";
import PersonCenter from "../components/Menu/Avatar";
export default {
  components: {
    VerticalMenu,
    HorizontalMenu,
    PersonCenter,
  },
  data() {
    return {
      title:"先河官网后台管理", //this.$store.state.projectInfo.SystemName,
      showTop: true,
    };
  },
  methods: {
  },
  created() {
    document.title = "先河官网后台管理";// this.$store.state.projectInfo.SystemName
    let showTopValue = this.$route.query.showTop;
    if (showTopValue != undefined && showTopValue == "0") {
      this.showTop = false;
    } else {
      this.showTop = true;
    }
  },
  computed: {
    leftMenuVisible() {
      return this.$store.state.leftMenuVisible;
    },
  },
  watch: {
    $route: function(newValue, oldValue) {
      if (newValue.query.showTop != undefined) {
        let value = newValue.query.showTop;
        if (value == "0") {
          this.showTop = false;
        } else {
          this.showTop = true;
        }
      } else {
        this.showTop = true;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.main {
  .header {
    //background-color: @navcolor;

    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    height: 64px;
    box-sizing: border-box;
    padding: 0 15px;
    background: url("~@/assets/img/menu_bg.png") no-repeat;
    background-size: 100% 100%;
    .header-logo span {
      margin-left: 15px;
      font-size: 30px;
    }
    .header-logo {
      display: flex;
      align-items: center;
      height: 100%;
    }
    .header-menu {
      display: flex;
      align-items: center;
      height: 100%;
    }
  }
}
.content {
  width: 100%;
  height: calc(100% - 64px);
  display: flex;

  .aside {
    height: 100%;
    z-index: 999;
  }
  .view-content {
    width: 0;
    flex: 1;
    flex-basis: auto;
    height: 100%;
    overflow: hidden;
    box-sizing: border-box;
  }
}
</style>
